module.exports = __webpack_public_path__ + "img/1fc0cc9.png";